import { useMemo } from "react";

import { Users } from "components/icons/generated";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { isSaasDistribution } from "utils/distribution";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";
import useSettingsMenuItems from "./useSettingsMenuItem";

const isSaas = isSaasDistribution();

const useManageOrganizationGroup = (): MainNavigationItem => {
  const { viewer } = useTypedContext(AccountContext);

  const isBillingAvailable = viewer.admin && isSaas;
  const isUsageAvailable = viewer.admin && isSaas;
  const isAuditTrailAvailable = viewer.admin;

  const { accountSettingsMenuItem, accountUsersSettingsMenuItem } = useSettingsMenuItems();

  return useMemo(
    () => ({
      id: "manage-organization",
      title: "Manage Organization",
      icon: Users,
      items: [
        {
          items: [
            ...(isBillingAvailable
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Billing]]
              : []),
            ...(isUsageAvailable
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Usage]]
              : []),
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.WorkerPools],
            ...(isAuditTrailAvailable
              ? [MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.AuditTrail]]
              : []),
            ...(accountUsersSettingsMenuItem ? [accountUsersSettingsMenuItem] : []),
            ...(accountSettingsMenuItem ? [accountSettingsMenuItem] : []),
          ],
        },
      ],
    }),
    [
      isBillingAvailable,
      isUsageAvailable,
      isAuditTrailAvailable,
      accountSettingsMenuItem,
      accountUsersSettingsMenuItem,
    ]
  );
};

export default useManageOrganizationGroup;
